import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, IconButton, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { selectUser } from "../reducers/userSlice";
import { GroupWellTransferList } from "./GroupWellTransferList";
import uuid from "react-uuid";

import { Cancel, ExpandMore, Info } from "@mui/icons-material";
import { addGroupWell, deleteGroupWell } from "../reducers/groupWellSlice";
import { selectLists, setListFilters } from "../reducers/listSlice";
import { useSnackbar } from "notistack";
import { useSocket } from "../context/useSocket";

const useStyles = makeStyles((theme) => ({
  root: {
    // height: 800,
    // minHeight: 800,
    width: '100%',
    overflow: 'scroll'
  },
}));

export const EditGroupWell = ({ listId, color, groupWellClose, wells, groupWell }) => {

  const [name, setName] = useState(groupWell?.name || "New Group Well");
  const [description, setDescription] = useState(groupWell?.description || "");
  const [uwis, setUwis] = useState(groupWell?.uwis || []);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const { socket } = useSocket();

  const user = useSelector(selectUser);
  const lists = useSelector(selectLists);
  const list = lists?.byId[listId];
  const filters = list?.filters || 0;

  const [completedLength] = useState(groupWell?.details?.length || 2000);
  const [clusterSpacing] = useState(groupWell?.details?.spacing || 100);
  const [tpm] = useState(groupWell?.details?.tpm || 2.5);
  const [consolidation, setConsolidation] = useState(groupWell?.fullCycle ? 'production+forecast' : 'production');
  const [visibility, setVisibility] = useState(groupWell?.public ? 'public' : 'private');

  const classes = useStyles();

  const dispatch = useDispatch();

  return (
    <Dialog 
      open={true} 
      onClose={groupWellClose}
      fullWidth={true}
      maxWidth="md"
      className={classes.root}
    >
      <DialogTitle>{groupWell?.id ? 'Edit' : 'New'} Group Well</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="normal"
          id="name"
          label="Group Well Name"
          type="text"
          fullWidth
          value={name}
          variant="outlined"
          placeholder="Group well name"
          onChange={e => setName(e.target.value)}
        />

        <TextField
          margin="normal"
          id="description"
          label="Description"
          type="text"
          fullWidth
          value={description}
          variant="outlined"
          placeholder="Group well description"
          onChange={e => setDescription(e.target.value)}
        />

        {/* <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <TextField
            margin="normal"
            id="length"
            label="Completed Length (m)"
            placeholder="1000"
            type="number"
            value={completedLength}
            variant="outlined"
            style={{width: 200}}
            onChange={e => setCompletedLength(Number(e.target.value))}
          />
          <TextField
            margin="normal"
            id="clusterSpacing"
            label="Cluster Spacing (m)"
            placeholder="25"
            type="number"
            value={clusterSpacing}
            variant="outlined"
            style={{width: 200}}
            onChange={e => setClusterSpacing(Number(e.target.value))}
          />
          <TextField
            margin="normal"
            id="tpm"
            label="TPM (tonne/m)"
            placeholder="2.5"
            type="number"
            value={tpm}
            variant="outlined"
            style={{width: 200}}
            onChange={e => setTpm(Number(e.target.value))}
          />
        </div> */}

        <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
          <FormLabel component="legend">Consolidation</FormLabel>
          <ToggleButtonGroup
            value={consolidation}
            exclusive
            onChange={updateConsolidation}
            style={{width: '100%'}}
          >
            <ToggleButton value="production" style={{width: '50%'}} color="primary">
              Production
            </ToggleButton>
            <ToggleButton value="production+forecast" style={{width: '50%'}} color="primary">
              Production + Forecast
            </ToggleButton>
          </ToggleButtonGroup>
        </FormControl>

        <div style={{display: 'flex', alignItems: 'center', margin: '10px 10px 20px 10px'}}>
          <Info color="primary" /><Typography component="span" style={{marginLeft: 10}}>
            {consolidation === 'production' ? 
              'Group well will consolidate historic production for all selected wells and fit a forecast to this data.'
            : 'Group well will consolidate historic and forecast production for all selected wells.'
            }
          </Typography>
        </div>

        <FormControl component="fieldset" style={{width: '100%', marginTop: 20, marginBottom: 20}}>
          <FormLabel component="legend">Visibility and Access</FormLabel>
          <ToggleButtonGroup
            value={visibility}
            exclusive
            onChange={updateVisibility}
            style={{width: '100%'}}
          >
            <ToggleButton value="private" style={{width: '50%'}} color="primary">
              Private
            </ToggleButton>
            <ToggleButton value="public" style={{width: '50%'}} color="primary">
              Public
            </ToggleButton>
          </ToggleButtonGroup>
        </FormControl>

        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>Add wells</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {Object.keys(filters)?.length > 0 && <Tooltip title="Remove Filters">
              <IconButton component="span" onClick={removeFilters}><Cancel /></IconButton>
            </Tooltip>}
            <Typography component="span">Active filters: {Object.keys(filters)?.length || 0}</Typography>
            <GroupWellTransferList 
              wells={wells} 
              uwis={uwis} 
              setUwis={setUwis}
              filtersLength={Object.keys(filters)?.length}
            /> 
          </AccordionDetails>
        </Accordion>

      </DialogContent>
      
      <DialogActions style={{display: 'flex', justifyContent: groupWell?.id ? 'space-between' : 'flex-end'}}>
        {groupWell?.id && 
        <Button onClick={(e) => handleDeleteGroupWell(e, groupWell?.id)} color="secondary" disabled={(user?.value?.email !== groupWell?.createdBy)}>
          Delete
        </Button>}
        <div>
          <Button onClick={groupWellClose} color="primary" style={{marginRight: 10}}>
            Cancel
          </Button>
          <Button 
            onClick={() => groupWellClick(uwis, user?.value?.email, (groupWell?.id || undefined))} 
            color="primary" 
            variant="contained" 
            disabled={(name?.length === 0) || (uwis?.length === 0) || (groupWell?.createdBy && groupWell?.createdBy !== user?.value?.email)}
          >
            {groupWell?.id ? 'Update' : 'Generate'}
          </Button>
        </div>  
      </DialogActions>
    </Dialog>
  );
  
  // FUNCTIONS
  function removeFilters(e) { // remove all well filters
    e.stopPropagation();
    e.preventDefault();
    // sourceWells = allWells;
    dispatch(setListFilters({listId: listId, filters: {}}));
  };

  function updateConsolidation(e, newValue) {
    newValue && setConsolidation(newValue);
  };

  function updateVisibility(e, newValue) {
    newValue && setVisibility(newValue);
  };


  async function groupWellClick(uwis, email, id) {
    try {
      const fullCycle = consolidation === 'production+forecast';

      let groupWell = {
        id: id || uuid(), 
        name, 
        description,
        public: visibility === 'public',
        createdBy: email, 
        lastModified: new Date(), 
        color, 
        uwis,
        details: {length: completedLength, spacing: clusterSpacing, tpm: tpm},
        fullCycle,
        production: {},
        forecast: {},
        params: null,
        eur: null,
        listId
      };

      let wellsData = [];

      uwis?.forEach(uwi => {
        const well = wells.byUwi[uwi];
        let production;
        let forecast;

        if (well?.status === 'processed') { // only if well is processed
          if (well?.production && Object.keys(well?.production)?.length > 0) {
            production = well.production;
          };
          if (!well.copy && well?.forecast && Object.keys(well?.forecast)?.length > 0) {
            forecast = well.forecast;
          };

          wellsData.push({production, forecast});
        };
      });

      const worker = new Worker("./groupWellWorker.js");

      enqueueSnackbar(`Processing group well ${groupWell?.name}...`, {
        variant: 'info',
        persist: true
      });

      worker.postMessage({wellsData, groupWell});

      worker.onmessage = (e) => {
        const groupWell = e?.data;
        if (!groupWell) return;

        if (!groupWell.fullCycle && socket && socket.readyState === 1) {
          socket.send(JSON.stringify({messageType: 'groupWell', payload: groupWell, userEmail: user?.value?.email}));
        } else {
          closeSnackbar();
          enqueueSnackbar(`Group well ${groupWell.name} processed successfully`, {variant: 'success'});
          dispatch(addGroupWell({...groupWell, checked: true})); // Add the full cycle group well directly
        };
      };

      groupWellClose();

      return;
    } catch (error) {
      console.log('Could not process request for new group well!');
      console.log(error);
      return;
    };
  };

  function handleDeleteGroupWell(e, groupWellId) {
    e.stopPropagation();
    dispatch(deleteGroupWell({groupWellId: groupWellId}));
    groupWellClose();
  };
};
